import { Link } from "react-router-dom";
import { ArrowRight, ExternalLink } from "lucide-react";

const items = [
  {
    label: "Real Estate Clients",
    body: "Buying, selling, or investing in Metro Atlanta with Fresh Vision Realty.",
    href: "https://freshvisionrealty.com",
    external: true,
    cta: "Visit Fresh Vision Realty",
  },
  {
    label: "Mortgage Clients",
    body: "Financing for self-employed buyers, 1099 earners, and investors.",
    href: "/mortgage",
    external: false,
    cta: "Explore mortgage services",
  },
  {
    label: "Licensed Agents",
    body: "Join the Fresh Vision Realty team and run on the systems we built.",
    href: "https://joinfreshvision.com",
    external: true,
    cta: "Join the team",
  },
];

const OtherWays = () => (
  <section className="py-16 md:py-20 bg-background border-t border-border">
    <div className="container mx-auto px-4">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
        Other Ways to Work With Marquetta
      </h2>
      <div className="grid md:grid-cols-3 gap-5 max-w-5xl mx-auto">
        {items.map((item) => {
          const inner = (
            <>
              <h3 className="font-bold text-lg mb-2">{item.label}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed mb-4 flex-1">
                {item.body}
              </p>
              <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all">
                {item.cta}
                {item.external ? (
                  <ExternalLink className="w-3.5 h-3.5" />
                ) : (
                  <ArrowRight className="w-3.5 h-3.5" />
                )}
              </span>
            </>
          );

          const className =
            "group flex flex-col p-6 bg-card border border-border rounded-xl hover:border-accent/50 hover:shadow-luxury transition-all duration-300";

          return item.external ? (
            <a
              key={item.label}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className={className}
            >
              {inner}
            </a>
          ) : (
            <Link key={item.label} to={item.href} className={className}>
              {inner}
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);

export default OtherWays;
